﻿import $ from "jquery";

let registerPageEvent = function (endpoint) {
    $.ajax({
        type: "GET",
        url: endpoint,
        success: function () {
            console.log("Success");
        },

        error: function () {
            console.log("Error");
        }
    });
};

$(function () {
    $("a.js--accordion-trigger[data-faqtrack]").on("click",
        function () {
            //check if the element is already expanded - if not track the event.
            if (this.getAttribute("aria-expanded") === "false") {
                console.log(this);
                var endpoint = $(this).data("faqtrack");

                registerPageEvent(endpoint);
            }
        });

    $("a.link.js--accordion-controller-trigger[data-faqtrack]").on("click",
        function () {
            const accordion = $(this).parents("div.accordion__wrapper.js--accordion-controller")[0];
            const faqs = $(accordion).find("a.js--accordion-trigger[data-faqtrack]");
            $(faqs).each(function (index, faq) {
                if (faq.getAttribute("aria-expanded") === "false") {
                    //check if the element is already expanded - if not track the event.
                    console.log(faq);
                    var endpoint = $(faq).data("faqtrack");
                    registerPageEvent(endpoint);
                }
            });
        });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/utils/Analytics.js
// module id = 16
// module chunks = 1